import React, { useState } from "react";

export function ceilToSelectable(time: any) {
  // current fixed stepsize: 5 minutes
  const mod = time.minutes() % 5;

  if (mod == 0) return time;

  return time.minutes(time.minutes() + (5 - mod));
}

export default (props: any) => {
  let _h: any = props.time.indexOf(":") > -1 ? props.time.split(":")[0] : "";
  let _m: any =
    props.time.indexOf(":") > -1 && props.time.indexOf(":") < props.time.length - 1
      ? props.time.split(":")[1]
      : "";
  _h = _h.indexOf("0") == 0 ? _h.slice(1) : _h;
  _m = _m.indexOf("0") == 0 ? _m.slice(1) : _m;

  const [pickerStatus, setPickerStatus] = useState("");

  const [selectedHour, setSelectedHour] = useState(_h);
  const [selectedMinute, setSelectedMinute] = useState(_m);
  const [separator, setSeparator] = useState(props.time.indexOf(":") > -1 ? ":" : "");

  if (_h != selectedHour) {
    setSelectedHour(_h);
    if (_h != "") setSeparator(":");
  } else if (_m != selectedMinute) {
    setSelectedMinute(_m);
    if (_m != "") setSeparator(":");
  }

  const _hours: number[] = Array.from(Array(24).keys());
  const _minutes: number[] = Array.from(Array(12), (_: any, i: number): number => i * 5);

  const getTwoDigitStringFromNumber: (number: number) => string = (number: number): string => {
    if (number < 10) return "0" + number;
    else return "" + number;
  };

  const selectHandle: (e: any) => void = (e: any): void => {
    setPickerStatus("has-focus");

    const val = e.target.value;
    const name = e.target.name;
    let h: any = selectedHour;
    let m: any = selectedMinute;
    let s: any = separator;
    let success: boolean = false;
    if (name == "hour" && val != "") {
      // maybe pre-select minute and set separator
      h = val;
      if (selectedMinute == "") {
        m = "0";
        s = ":";
      }
    } else if (name == "hour" && val == "") {
      // also unselect minute and hide separator
      h = val;
      m = "";
      s = "";
    } else if (name == "minute" && val != "") {
      // maybe pre-select hour and set separator
      m = val;
      if (selectedHour == "") {
        h = "0";
        s = ":";
      }
    } else if (name == "minute" && val == "") {
      // also unselect hour and hide separator
      m = val;
      h = "";
      s = "";
    }

    s == ":"
      ? (success = props.handleChange(
          "" + getTwoDigitStringFromNumber(h) + s + getTwoDigitStringFromNumber(m),
        ))
      : (success = props.handleChange(""));

    if (success) {
      setSelectedHour(h);
      setSelectedMinute(m);
      setSeparator(s);
    }
  };

  const blurHandle: (e: any) => void = (e: any): void => {
    setPickerStatus("");
  };

  const focusHandle: (e: any) => void = (e: any): any => {
    setPickerStatus("has-focus");
  };

  return (
    <>
      <div className={"inb-simple-time-picker " + pickerStatus}>
        <select
          name="hour"
          value={selectedHour}
          onChange={(e) => selectHandle(e)}
          onBlur={(e) => blurHandle(e)}
          onFocus={(e) => focusHandle(e)}
          disabled={props.readOnly}
        >
          <option key="_" value=""></option>
          {_hours.map((hour, index) => {
            return (
              <option key={index} value={hour}>
                {getTwoDigitStringFromNumber(hour)}
              </option>
            );
          })}
        </select>
        <div className={props.readOnly ? "separator readonly" : "separator"}>{separator}</div>
        <select
          name="minute"
          value={selectedMinute}
          onChange={(e) => selectHandle(e)}
          onBlur={(e) => blurHandle(e)}
          onFocus={(e) => focusHandle(e)}
          disabled={props.readOnly}
        >
          <option key="_" value=""></option>
          {_minutes.map((minute, index) => {
            return (
              <option key={index} value={minute}>
                {getTwoDigitStringFromNumber(minute)}
              </option>
            );
          })}
        </select>
      </div>
    </>
  );
};
